import { useLayoutEffect } from 'react'
import { OpenAPI } from '@/api/portal'

export const useApiConfig = () => {
    useLayoutEffect(() => {
        // Set API base URL
        OpenAPI.BASE = import.meta.env.API_URL || ''
    }, [])
}
